var api = require("!../node_modules/.pnpm/style-loader@1.1.3_webpack@4.42.0_supports-color@6.1.0_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../node_modules/.pnpm/css-loader@3.5.1_webpack@4.42.0_supports-color@6.1.0_/node_modules/css-loader/dist/cjs.js??ref--13-1!../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??embedded!../node_modules/.pnpm/sass-loader@8.0.2_sass@1.26_84492517940de98dee0bbf9298a67d8a/node_modules/sass-loader/dist/cjs.js??ref--13-3!./styles.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;